import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { AppNotificaciones } from './app.notificaciones';
import { LayoutService } from '../service/layout.service';
import { AuthService } from '@/pages/service/auth.service';
import { ImageModule } from 'primeng/image';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AppConfigurator, AppNotificaciones, ImageModule],
    template: ` <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
                <i class="pi pi-bars"></i>
            </button>
            <a class="layout-topbar-logo" routerLink="/dashboard">
                <p-image src="./images/isologo.png" alt="Image" width="50" />
                <span>Virtual Araucano</span>
            </a>
        </div>

        <div class="layout-topbar-actions">
            <div class="layout-config-menu">
                @if (mostrarNotificaciones) {
                    <app-notificaciones />
                }
                <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                    <i
                        [ngClass]="{
                            'pi ': true,
                            'pi-moon': layoutService.isDarkTheme(),
                            'pi-sun': !layoutService.isDarkTheme()
                        }"
                    ></i>
                </button>
                <div class="relative">
                    <button
                        class="layout-topbar-action layout-topbar-action-highlight"
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="animate-scalein"
                        leaveToClass="hidden"
                        leaveActiveClass="animate-fadeout"
                        [hideOnOutsideClick]="true"
                    >
                        <i class="pi pi-palette"></i>
                    </button>
                    <app-configurator />
                </div>
            </div>

            <!--<button
                class="layout-topbar-menu-button layout-topbar-action"
                pStyleClass="@next"
                enterFromClass="hidden"
                enterActiveClass="animate-scalein"
                leaveToClass="hidden"
                leaveActiveClass="animate-fadeout"
                [hideOnOutsideClick]="true"
            >
                <i class="pi pi-ellipsis-v"></i>
            </button>-->

            <!--<div class="layout-topbar-menu hidden lg:block">
                <div class="layout-topbar-menu-content">
                    <button type="button" class="layout-topbar-action">
                        <i class="pi pi-calendar"></i>
                        <span>Calendar</span>
                    </button>
                    <button type="button" class="layout-topbar-action">
                        <i class="pi pi-inbox"></i>
                        <span>Messages</span>
                    </button>
                    <button type="button" class="layout-topbar-action">
                        <i class="pi pi-user"></i>
                        <span>Profile</span>
                    </button>
                </div>
            </div>-->
        </div>
    </div>`
})
export class AppTopbar {
    items!: MenuItem[];

    /** El panel de notificaciones solo aplica al administrador principal (sin sede asignada). */
    readonly mostrarNotificaciones: boolean;

    constructor(
        public layoutService: LayoutService,
        private readonly authService: AuthService
    ) {
        const user = this.authService.user ? JSON.parse(this.authService.user) : null;
        const mainRole = (user?.roles?.[0] ?? '').toLowerCase();
        this.mostrarNotificaciones =
            !!user && mainRole !== 'superadministrador' && (user.sede_id === null || user.sede_id === undefined);
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }
}
